
import { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Scroll to top whenever location changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const menuItems = [
    { label: 'Sobre', href: '/quem-somos', type: 'route' },
    { label: 'Serviços', href: '/servicos', type: 'route' },
    { label: 'Projetos', href: '/projetos', type: 'route' },
    { label: 'Contato', href: '/contato', type: 'route' }
  ];

  const handleNavigation = (item: typeof menuItems[0]) => {
    if (item.type === 'route') {
      navigate(item.href);
    } else if (item.type === 'anchor') {
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          const element = document.querySelector(item.href);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        const element = document.querySelector(item.href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
    setIsMenuOpen(false);
  };

  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleLinkClick = (to: string) => {
    navigate(to);
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={handleLogoClick}>
            <img 
              src="https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/eb4ddffc68ef7a0a24165f4c03913501.png" 
              alt="P&P Engenharia e Arquitetura" 
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => handleLinkClick('/quem-somos')}
              className="text-[#3F3F3F] hover:text-[#5C1A24] transition-colors cursor-pointer"
            >
              Sobre
            </button>
            <button 
              onClick={() => handleLinkClick('/servicos')}
              className="text-[#3F3F3F] hover:text-[#5C1A24] transition-colors cursor-pointer"
            >
              Serviços
            </button>
            <button 
              onClick={() => handleLinkClick('/projetos')}
              className="text-[#3F3F3F] hover:text-[#5C1A24] transition-colors cursor-pointer"
            >
              Projetos
            </button>
            <button 
              onClick={() => handleLinkClick('/contato')}
              className="text-[#3F3F3F] hover:text-[#5C1A24] transition-colors cursor-pointer"
            >
              Contato
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-[#3F3F3F] hover:text-[#5C1A24] cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              {menuItems.map((item) => (
                <button
                  key={item.label}
                  onClick={() => handleNavigation(item)}
                  className="text-[#3F3F3F] hover:text-[#5C1A24] font-medium transition-colors duration-300 cursor-pointer text-left"
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
